import CountertopCommon from "../countertopCommon";

export default class Countertop extends CountertopCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'center_island_countertop';
    this.dbName = 'Center Island Countertop';
    this.partName = 'Island Countertop';
    this.homePageTitle = 'Center Island Countertop';
    this.translateId = "visualizer.kitchen.center_island.center_island_countertop";
    this.isStoneFeature = true;
    this.toggleSwitchedOffByUser = false;  // is used for returning toggle back when feature is found
  }

  disabledClick() {
    const centerIslandParent = this.getParent();
    if (!this.disabled && centerIslandParent.cabinet.disabled) {
      centerIslandParent.cabinet.disabled = false;
      centerIslandParent.cabinet.disabledClick();
    }
  }

  load(dbFeature) {
    dbFeature.metaData["RoomLayout"] = (dbFeature.metaData["RoomLayout"] && dbFeature.metaData["RoomLayout"].filter(roomLayout => roomLayout.includes("I"))) || [];
    return super.load_(dbFeature, new Countertop());
  }

  setLayers(layout) {

    const cabinet = this.getParent().cabinet;
    if (cabinet && (cabinet.disabled || !cabinet.featureGroupEnabled)) {
      super.hideLayers();
      return
    }

    return super.setLayers(layout);
  }

  setDefault() { // this is added because of the layout
    const layout = this.getParent && this.getParent().layout;
    if (layout && layout.getCurrentLayoutAbbreviation) {
      const currentLayoutAbbreviation = layout.getCurrentLayoutAbbreviation();
      if (currentLayoutAbbreviation && !currentLayoutAbbreviation.includes("I")) {
        return null
      }
    }
    return super.setDefault()
  }

  getArrayOfConditions() {
    return [{
      propName: 'RoomLayout',
      propValue: this.getParent().layout.getCurrentLayoutAbbreviation()
    }];
  }

  setZIndex(zIndexes) {
    if(zIndexes) {
      const zIndex = zIndexes.CenterIsland.Countertop;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
      if (this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndex;
      }
    }
  }

  canUseNavigationFilterSteps() {
    const parent = this.getParent();
    return parent.edge // display filters only if edges exist
  }

  canUseNavigationFilter() {
    return true //TODO[Artem] add here features filters check
  }

}
